export default __webpack_public_path__ + "static/851-0313124a8be86f139b49049c1b764120.gif";